import angular from 'angular';

const couponServices = angular.module('applicationModule.couponsServices', []);

couponServices.factory('Coupon', ['CouponAPI', function (CouponAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return CouponAPI.getList(appId, params).then(function (response) {
                return response.data;
            });
        },
        get: function (couponId) {
            return CouponAPI.getCoupon(couponId);
        },
        save: function (coupon, editMode) {
            if (editMode) {
                return CouponAPI.editCoupon(coupon);
            } else {
                return CouponAPI.createCoupon(coupon);
            }
        },
        remove: function (couponId) {
            return CouponAPI.removeCoupon(couponId);
        },
        autocompletePlacement: function (appId, text) {
            return CouponAPI.autocompletePlacement(appId, text);
        },
        importData: function (appId, couponId, file) {
            return CouponAPI.importData(appId, couponId, file);
        },
        importAllData: function (appId, file) {
            return CouponAPI.importAllData(appId, file);
        },
        importShops: function (appId, couponId, file) {
            return CouponAPI.importShops(appId, couponId, file);
        },
        importScratchCards: function (appId, file) {
            return CouponAPI.importScratchCards(appId, file);
        },
        getExampleXls: function () {
            return CouponAPI.getExampleXls();
        },
        getImportShopsExampleXls: function () {
            return CouponAPI.getImportShopsExampleXls();
        },
        deleteAllShopsByCouponId: function (appId, couponId) {
            return CouponAPI.deleteAllShopsByCouponId(appId, couponId);
        },
        getShopsByCoupon: function (appId, couponId) {
            return CouponAPI.getShopsByCoupon(appId, couponId);
        },
        showBadgeForShop: function (appId, couponId, showLimited) {
            return CouponAPI.showBadgeForShop(appId, couponId, showLimited);
        },
        exportDataById: function (appId, couponId) {
            return CouponAPI.exportDataById(appId, couponId);
        },
        exportData: function (from_date, to_date, appId, checkedCoupons, isActive) {
            return CouponAPI.exportData(from_date, to_date, appId, checkedCoupons, isActive);
        },
        getCouponData: function (appId, couponId) {
            return CouponAPI.getCouponData(appId, couponId);
        },
        getBadgeTypes: function (appId) {
            return CouponAPI.getBadgeTypes(appId);
        },
        changeOrder: function (data) {
            return CouponAPI.changeOrder(data);
        },
        getActiveOptions: function () {
            return CouponAPI.getActiveOptions();
        },
        searchShop: function (appId, search) {
            return CouponAPI.searchShop(appId, search);
        },
        publish: function (appId, couponIds) {
            return CouponAPI.publish(appId, couponIds);
        },
        getStatusLabels: function (appId) {
            return CouponAPI.getStatusLabels(appId);
        },
        getTypes: function (appId) {
            return CouponAPI.getTypes(appId);
        },
        getScratchCardTypes: function (appId) {
            return CouponAPI.getScratchCardTypes(appId);
        },
        getImportedShopList: function (appId, couponId, params) {
            return CouponAPI.getImportedShopList(appId, couponId, params).then(function (response) {
                return response.data;
            });
        }
    };
}]);

couponServices.service('CouponAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/coupon/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.createCoupon = function (coupon) {
        return $http.post(API_URL, coupon);
    };
    this.getCoupon = function (couponId) {
        return $http.get(API_URL + couponId);
    };

    this.editCoupon = function (coupon) {
        return $http.put(API_URL + coupon.id, coupon);
    };

    this.removeCoupon = function (couponId) {
        return $http.delete(API_URL + couponId);
    };

    this.autocompletePlacement = function (appId, text) {
        return $http.get(API_URL + 'autocomplete-placement/' + appId, {params: {search: text}});
    };

    this.importData = function (appId, couponId, file) {
        return Upload.upload({
            url: API_URL + appId + '/import/data/' + couponId,
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };

    this.getImportedShopList = function (appId, couponId, params) {
        return $http.get(API_URL + appId + '/import/shops/' + couponId, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId
            })
        });
    };

    this.importShops = function (appId, couponId, file) {
        return Upload.upload({
            url: API_URL + appId + '/import/shops/' + couponId,
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };

    this.importAllData = function (appId, file) {
        return Upload.upload({
            url: API_URL + appId + '/import/',
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };

    this.importScratchCards = function (appId, file) {
        return Upload.upload({
            url: API_URL + appId + '/import/scratch-cards/',
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };

    this.getExampleXls = function () {
        return $http.get(API_URL + 'download/example');
    };

    this.getImportShopsExampleXls = function () {
        return $http.get(API_URL + 'download/example-import-shops');
    };

    this.showBadgeForShop = function (appId, couponId, showLimited) {
        return $http.get(API_URL + appId + '/coupons/' + couponId + '/show-badge', {
            application_id: appId,
            coupon_id: couponId,
            params: {show_limited_stores_ui: showLimited}
        });
    };

    this.exportDataById = function (appId, couponId) {
        return $http.post(API_URL + 'data/export-by-id', {application_id: appId, coupon_id: couponId});
    };

    this.exportData = function (from_date, to_date, appId, checkedCoupons, isActive) {
        return $http.post(API_URL + 'data/export', {
            from_date: from_date,
            to_date: to_date,
            application_id: appId,
            checked_coupons: checkedCoupons,
            is_active: isActive
        });
    };

    this.getCouponData = function (appId, couponId) {
        return $http.get(API_URL + appId + '/import/data/' + couponId);
    };

    this.getShopsByCoupon = function (appId, couponId) {
        return $http.get(API_URL + appId + '/coupons/' + couponId + '/get-shops', {
            application_id: appId,
            coupon_id: couponId
        });
    };

    this.deleteAllShopsByCouponId = function (appId, couponId) {
        return $http.get(API_URL + appId + '/coupons/' + couponId + '/delete/shops', {
            application_id: appId,
            coupon_id: couponId
        });
    };

    this.getBadgeTypes = function (appId) {
        return $http.get(API_URL + 'badges/' + appId);
    };

    this.changeOrder = function (data) {
        const url = API_URL + 'change-order/';

        return $http.post(url, data);
    };
    this.getActiveOptions = function () {
        return $http.get(API_URL + 'active/options');
    };

    this.searchShop = function (appId, text) {
        return $http.get(API_URL + appId + '/shops', {params: {search: text}});
    };
    this.publish = function (appId, couponIds) {
        return $http.post(API_URL + appId + '/publish', {coupon_ids: couponIds});
    };
    this.getStatusLabels = function (appId) {
        return $http.get(API_URL + appId + '/status-labels');
    };
    this.getTypes = function (appId) {
        return $http.get(API_URL + appId + '/types');
    };
    this.getScratchCardTypes = function (appId) {
        return $http.get(API_URL + appId + '/scratchCardTypes');
    };

}]);

export default couponServices;
